import { getAudioCleanerTaskResult } from '~/composables/api/audioCleaner.js'

export const AUDIO_CLEANER_POLL_INTERVAL_MS = 3000
export const AUDIO_CLEANER_POLL_MAX_ATTEMPTS = 60

export function resolveAudioCleanerResultUrl(data) {
  if (typeof data === 'string' && data.trim()) return data.trim()
  if (Array.isArray(data)) {
    for (const item of data) {
      const resolved = resolveAudioCleanerResultUrl(item)
      if (resolved) return resolved
    }
    return ''
  }
  const result = data?.result
  if (Array.isArray(result)) {
    for (const item of result) {
      const resolved = resolveAudioCleanerResultUrl(item)
      if (resolved) return resolved
    }
  }
  if (typeof result === 'string' && result.trim()) return result.trim()
  if (data && typeof data === 'object') {
    const url =
      data.audio_url ||
      data.output_url ||
      data.result_audio_url ||
      data.after_audio_url ||
      data.preview_audio_url ||
      data.url ||
      ''
    if (typeof url === 'string' && url.trim()) return url.trim()
  }
  return ''
}

export function isAudioCleanerSuccess(data) {
  return Number(data?.status) === 1
}

export function isAudioCleanerFailed(data) {
  return Number(data?.status) === 2
}

export function isAudioCleanerPending(data) {
  return Number(data?.status) === 0
}

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

/** @param {string} taskId */
export async function pollAudioCleanerResult(taskId, options = {}) {
  const id = String(taskId || '').trim()
  if (!id) throw new Error('noise_reduction_missing_task_id')

  const interval = options.intervalMs ?? AUDIO_CLEANER_POLL_INTERVAL_MS
  const maxAttempts = options.maxAttempts ?? AUDIO_CLEANER_POLL_MAX_ATTEMPTS

  for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
    const res = await getAudioCleanerTaskResult({ task_id: id })
    if (Number(res.code) !== 100000) {
      throw new Error(res.message || 'noise_reduction_poll_failed')
    }

    const data = res.data
    if (isAudioCleanerSuccess(data)) return data
    if (isAudioCleanerFailed(data)) {
      throw new Error(data?.message || 'noise_reduction_task_failed')
    }
    if (attempt < maxAttempts - 1) {
      await sleep(interval)
    }
  }

  throw new Error('noise_reduction_timeout')
}
